import { DateTime } from 'luxon';
import { Contract, EPageViewType } from '../../types';
import { useFormContext } from 'react-hook-form';
import { useContractStandingData } from '../../hooks/useContractStandingData';
import { useEffect } from 'react';
import { FormCard } from '@portal_components/components/FormCard';
import { FormDropdown } from '@portal_components/components/FormDropdown';
import { FormTextInput } from '@portal_components/components/FormTextInput';

interface ContractBillingTabProps {
  readonly: boolean;
  viewType: EPageViewType;
}

export const ContractBillingTab = ({ readonly, viewType }: ContractBillingTabProps) => {
  const { watch, setValue } = useFormContext<Contract>();
  const {
    standingData: { standingDataBillingTypeList, standingDataBillingScheduleList }
  } = useContractStandingData();
  const months = [...Array(12).keys()].map(month => DateTime.fromObject({ month: month + 1 }).toFormat('MMMM'));
  const [billingFrequency, billPeriod] = watch(['billingFrequency', 'billPeriod']);

  useEffect(() => {
    const sdRecord = standingDataBillingScheduleList.find(({ billPeriod: period }) => period === billPeriod);
    if (!sdRecord) return;
    setValue('billingFrequency', sdRecord.billingFrequencyId);
  }, [billPeriod, setValue, standingDataBillingScheduleList]);

  return (
    <div className="flex flex-col w-full">
      <FormCard columns={2} title="Billing">
        <FormDropdown<Contract> title="Type" name="billingType" readonly={viewType !== EPageViewType.ADD} mandatory placeholder="Select..." elementsForDisplay={standingDataBillingTypeList} />
        <FormDropdown<Contract>
          title="Billing Period"
          name="billPeriod"
          mandatory
          placeholder="Select..."
          elementsForDisplay={standingDataBillingScheduleList.map(({ billingScheduleId, billPeriod }) => ({
            title: billingScheduleId,
            value: billPeriod
          }))}
          readonly={readonly}
        />
        <FormTextInput<Contract> title="Day" name="billDay" mandatory readonly={readonly} placeholder="1-27" />
        <FormTextInput<Contract> title="Lease Purchase Term" name="leasePurchaseTerm" readonly={readonly} />
        {billingFrequency === '28' && (
          <FormDropdown<Contract>
            title="Adjustment Month"
            name="billAdjustmentMonth"
            mandatory
            placeholder="Select..."
            elementsForDisplay={months.map(value => ({ title: value, value }))}
            readonly={readonly}
          />
        )}
      </FormCard>
    </div>
  );
};
